<script setup>
import { dropdownTriggers } from '@/constants/dropdown';

const props = defineProps({
  // all search filters
  modelValue: {
    type: Object,
    default: () => ({}),
  },

  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['update:modelValue', 'set', 'click']);

const modelData = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const uiDropdownRef = ref(null);
const visible = computed(() => uiDropdownRef.value?.visible);

function open() {
  uiDropdownRef.value?.open();
}

const passengersCount = computed(() => {
  const { adults, children, infants } = modelData.value;
  let count = adults;

  if (children) count += children;
  if (infants) count += infants;

  return count;
});

// reset modelData on dropdown close
watch(visible, () => {
  if (visible.value) return;
  modelData.value = cloneObject(props.modelValue);
});

function handleClick(close) {
  emit('update:modelValue', modelData.value);
  emit('set');
  close();
}

defineExpose({ open });
</script>

<template>
  <UiDropdown
    ref="uiDropdownRef"
    class="ui-seats-select"
    :trigger-event="dropdownTriggers.click"
    :disabled="disabled"
    use-v-if
    @click="emit('click')"
  >
    <template #trigger="{ visible: dropdownVisible }">
      <div
        class="ui-seats-select__trigger"
        :class="{
          'ui-seats-select__trigger--opened': dropdownVisible,
        }"
      >
        <CIcon class="ui-seats-select__icon" name="user-2" />

        <div class="ui-seats-select__text">
          <span class="ui-seats-select__font ui-seats-select__font--text">
            {{ passengersCount }}
            <span class="hidden-desktop">{{
              $t('form.passengers', { count: passengersCount })
            }}</span>
          </span>
        </div>
      </div>
    </template>

    <template #content="{ close }">
      <div class="ui-seats-select__content" @click.stop>
        <BundlesSeatsSelect
          v-model="modelData"
          button-text-key="form.set"
          hide-button
        />

        <UiButton
          class="ui-seats-select__button"
          theme="secondary"
          @click="handleClick(close)"
        >
          <span class="ui-seats-select__font ui-seats-select__font--button">
            {{ $t('form.set') }}
          </span>
        </UiButton>
      </div>
    </template>
  </UiDropdown>
</template>
